import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthRepository } from 'src/app/auth/state/auth.repository';
import { WeekCalculatorService } from 'src/app/services/week-calculator.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
})
export class MessagesComponent {

  weeks = [
    { week_number: 1, name: "Fatos sobre a dor lombar" },
    { week_number: 2, name: "Causas da dor lombar" },
    { week_number: 3, name: "Repouso ou exercícios ativos?" },
    { week_number: 4, name: "Exercício é bom para você!" },
    { week_number: 5, name: "Mantenha-se ativo!" },
    { week_number: 6, name: "Mantenha-se ativo!" },
    { week_number: 7, name: "Como se manter ativo?" },
    { week_number: 8, name: "Quando ver o seu médico?" },
  ]
  currentWeek: number = 1;

  constructor(
    private router: Router,
    private authRepo: AuthRepository,
    private weekCalc: WeekCalculatorService,
  ) {
    this.currentWeek = this.weekCalc.calcWeekNumber(this.authRepo.getState().user.start_at);
  }

  async onItemClick(week) {
    this.router.navigateByUrl(`messages/${week.week_number}`)
    return
  }

}
